import type { RootState } from '@/store/store';

export const selectFaviconSettings = (state: RootState) => state.pages.currentPage?.faviconSettings;
